<template>
  <div class="host-template">
    <el-row class="dialogItem">
      <span>是否是绿色主播</span>
      <el-select v-model="anchorData.greenHost" style="width: 400px" placeholder="请选择" clearable>
        <el-option key="0" label="不是" :value="0"> </el-option>
        <el-option key="1" label="是" :value="1"> </el-option>
      </el-select>
    </el-row>
    <el-row class="dialogItem">
      <span>是否一筛主播 </span>
      <el-select v-model="anchorData.firstProbationHost" style="width: 400px" placeholder="请选择" clearable>
        <el-option key="0" label="不是" :value="0"> </el-option>
        <el-option key="1" label="是" :value="1"> </el-option>
      </el-select>
    </el-row>
    <el-row class="dialogItem">
      <span>是否是纯绿色主播</span>
      <el-select v-model="anchorData.continuousGreenHosts" style="width: 400px" placeholder="请选择" clearable>
        <el-option key="0" label="不是" :value="0"> </el-option>
        <el-option key="1" label="是" :value="1"> </el-option>
      </el-select>
    </el-row>
    <el-row class="dialogItem">
      <span>是否有离线视频</span>
      <el-select v-model="anchorData.hasOfflineVideo" style="width: 400px" placeholder="请选择" clearable>
        <el-option key="0" label="不是" :value="0"> </el-option>
        <el-option key="1" label="是" :value="1"> </el-option>
      </el-select>
    </el-row>
    <el-row class="dialogItem">
      <span>是否是新主播</span>
      <el-select v-model="anchorData.isNewHost" style="width: 400px" placeholder="请选择" clearable
        @change="changeIsNewHost">
        <el-option key="0" label="不是" :value="0"> </el-option>
        <el-option key="1" label="是" :value="1"> </el-option>
      </el-select>
    </el-row>
    <el-row class="dialogItem" style="padding-left: 140px;" v-if="anchorData.isNewHost == 1">
      <el-radio-group v-model="anchorData.phase" @change="changeDate">
        <el-radio :label="0">无权限</el-radio>
        <el-radio :label="1">锁定未开启</el-radio>
        <el-radio :label="2">等待开启</el-radio>
        <el-radio :label="3">开启</el-radio>
        <el-radio :label="4">过期</el-radio>
      </el-radio-group>
    </el-row>
    <el-row class="dialogItem">
      <span>是否是B面主播</span>
      <el-select v-model="anchorData.bSideHost" style="width: 400px" placeholder="请选择" clearable>
        <el-option key="0" label="不是" :value="0"> </el-option>
        <el-option key="1" label="是" :value="1"> </el-option>
      </el-select>
    </el-row>
    <el-row class="dialogItem">
      <span>是否是beautiful主播</span>
      <el-select v-model="anchorData.beautifulHost" style="width: 400px" placeholder="请选择" clearable>
        <el-option key="0" label="不是" :value="0"> </el-option>
        <el-option key="1" label="是" :value="1"> </el-option>
      </el-select>
    </el-row>
    <el-row class="dialogItem">
      <span>是否潜力主播</span>
      <el-select v-model="anchorData.potentialHost" style="width: 400px" placeholder="请选择" clearable>
        <el-option key="0" label="不是" :value="0"> </el-option>
        <el-option key="1" label="是" :value="1"> </el-option>
      </el-select>
    </el-row>
    <el-row class="dialogItem">
      <span>自定义主播ID</span>
      <el-checkbox v-model="localIsExcludeAnchorId" style="margin-right: 10px" @change="handleIsExcludeAnchorIdChange">排除</el-checkbox>
      <el-button type="primary" @click="addAnchorId">添加</el-button>
    </el-row>
    <el-row class="dialogItem">
      <span>代理ID</span>
      <el-checkbox v-model="localIsAgentId" style="margin-right: 10px" @change="handleIsAgentIdChange">排除</el-checkbox>
      <el-input v-model="anchorData.agentId" style="width: 400px" placeholder="请输入"></el-input>
    </el-row>
    <el-row class="dialogItem">
      <span>角色性别</span>
      <el-select v-model="anchorData.sex" style="width: 400px" placeholder="请选择" @input="changeDate" clearable>
        <el-option key="-1" label="全部" :value="-1"> </el-option>
        <el-option key="0" label="女性" :value="0"> </el-option>
        <el-option key="1" label="男性" :value="1"> </el-option>
      </el-select>
    </el-row>
    <el-row class="dialogItem">
      <span>月评等级</span>
      <el-select v-model="anchorData.hostMonthLevel[0]" style="width: 180px; margin-right: 10px" placeholder="请选择"
        @input="changeDate" clearable>
        <el-option key="全部" label="全部" value=""> </el-option>
        <el-option key="Lv1" label="Lv1" value="1"> </el-option>
        <el-option key="Lv2" label="Lv2" value="2"> </el-option>
        <el-option key="Lv3" label="Lv3" value="3"> </el-option>
        <el-option key="Lv4" label="Lv4" value="4"> </el-option>
        <el-option key="Lv5" label="Lv5" value="5"> </el-option>
        <el-option key="Lv6" label="Lv6" value="6"> </el-option>
        <el-option key="Lv7" label="Lv7" value="7"> </el-option>
        <el-option key="Lv8" label="Lv8" value="8"> </el-option>
      </el-select>
      <span class="to"> ~ </span>
      <el-select v-model="anchorData.hostMonthLevel[1]" style="width: 180px" placeholder="请选择" @input="changeDate"
        clearable>
        <el-option key="全部" label="全部" value=""> </el-option>
        <el-option key="Lv1" label="Lv1" value="1"> </el-option>
        <el-option key="Lv2" label="Lv2" value="2"> </el-option>
        <el-option key="Lv3" label="Lv3" value="3"> </el-option>
        <el-option key="Lv4" label="Lv4" value="4"> </el-option>
        <el-option key="Lv5" label="Lv5" value="5"> </el-option>
        <el-option key="Lv6" label="Lv6" value="6"> </el-option>
        <el-option key="Lv7" label="Lv7" value="7"> </el-option>
        <el-option key="Lv8" label="Lv8" value="8"> </el-option>
      </el-select>
    </el-row>
    <el-row class="dialogItem">
      <span>主播质量等级</span>
      <el-select v-model="anchorData.appraiseLevel[0]" style="width: 180px; margin-right: 10px" placeholder="请选择"
        @input="changeDate" clearable>
        <el-option key="全部" label="全部" value=""> </el-option>
        <el-option key="G0" label="G0" value="0"> </el-option>
        <el-option key="G1" label="G1" value="1"> </el-option>
        <el-option key="G2" label="G2" value="2"> </el-option>
        <el-option key="G3" label="G3" value="3"> </el-option>
      </el-select>
      <span class="to"> ~ </span>
      <el-select v-model="anchorData.appraiseLevel[1]" style="width: 180px" placeholder="请选择" @input="changeDate"
        clearable>
        <el-option key="全部" label="全部" value=""> </el-option>
        <el-option key="G0" label="G0" value="0"> </el-option>
        <el-option key="G1" label="G1" value="1"> </el-option>
        <el-option key="G2" label="G2" value="2"> </el-option>
        <el-option key="G3" label="G3" value="3"> </el-option>
      </el-select>
    </el-row>

    <el-row class="dialogItem">
      <span>匹配接通率</span>
      <el-input v-model="anchorData.matchCallStartRate[0]" style="width: 180px; margin-right: 10px"
        @input="changeDate"></el-input>
      <span class="to"> ~ </span>
      <el-input v-model="anchorData.matchCallStartRate[1]" style="width: 180px" @input="changeDate"></el-input>
    </el-row>
    <el-row class="dialogItem">
      <span>注册时间</span>
      <el-date-picker style="width: 400px" v-model="anchorData.registerTime" type="daterange" clearable
        range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="timestamp"
        :unlink-panels="true" @input="changeDate">
      </el-date-picker>
    </el-row>
    <el-row class="dialogItem">
      <span>主播激活时间</span>
      <el-date-picker style="width: 400px" v-model="anchorData.positiveTime" type="daterange" clearable
        range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="timestamp"
        :unlink-panels="true" @input="changeDate">
      </el-date-picker>
    </el-row>
    <el-row class="dialogItem">
      <span>流失时间</span>
      <el-input v-model="anchorData.lostTime" style="width: 400px"></el-input>
    </el-row>
    <el-row class="dialogItem">
      <span>版本号限制</span>
      <el-select v-model="anchorData.verSymbol" style="width: 100px;margin-right: 10px">
        <el-option label="≤" :value="1"></el-option>
        <el-option label="≥" :value="2"></el-option>
      </el-select>
      <el-input v-model="anchorData.verLimit" type="number" style="width: 290px"></el-input>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'HostTemplate',
  props: {
    anchorData: {
      type: Object,
      default: () => ({
        greenHost: null,
        firstProbationHost: null,
        continuousGreenHosts: null,
        hasOfflineVideo: null,
        isNewHost: null,
        beautifulHost: null,
        potentialHost: null,
        bSideHost: null,
        phase: null,
        userGroup: '',
        agentId: '',
        sex: '',
        appraiseLevel: ['', ''],
        hostMonthLevel: ['', ''],
        matchCallStartRate: ['', ''],
        registerTime: '',
        positiveTime: '',
        lostTime: '',
        verSymbol: 1,
        verLimit: '',
      })
    },
    isAgentId: {
      type: Boolean,
      default: false
    },
    isExcludeAnchorId: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      localIsAgentId: this.isAgentId,
      localIsExcludeAnchorId: this.isExcludeAnchorId
    }
  },
  watch: {
    isAgentId(newVal) {
      this.localIsAgentId = newVal
    },
    isExcludeAnchorId(newVal) {
      this.localIsExcludeAnchorId = newVal
    }
  },
  methods: {
    changeDate() {
      this.$emit('changeDate')
    },
    changeIsNewHost() {
      if (this.anchorData.isNewHost == 1) {
        this.anchorData.phase = null
      }
    },
    addAnchorId() {
      this.$emit('addAnchorId')
    },
    handleIsAgentIdChange(value) {
      this.$emit('update:isAgentId', value)
    },
    handleIsExcludeAnchorIdChange(value) {
      this.localIsExcludeAnchorId = value
      this.$emit('update:isExcludeAnchorId', value)
    }
  }
}
</script>

<style scoped lang="scss">
.dialogItem {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 30px;
  text-align: left;
  padding-left: 50px;
  color: #000;

  >span {
    width: 160px;
    margin-right: 10px;
    text-align: right;
    font-size: 15px;
    font-weight: bold;

    &.to {
      width: 50px;
      text-align: center;
    }
  }
}
</style> 
